import * as type from './type';

export const getAlbum = (params) => {
  return {
    type: type.GET_ALBUM,
    params,
  };
};

export const getAlbumSuccess = (payload) => {
  return {
    type: type.GET_ALBUM_SUCCESS,
    payload,
  };
};


export const deleteAlbumRequest = (payload) => {
  return {
    type: type.DETETE_ALBUM_REQUEST,
    payload,
  };
};

export const getAlbumDetail = (params) => {
  return {
    type: type.GET_ALBUM_DETAIL,
    params,
  };
};

export const getAlbumDetailSuccess = (payload) => {
  return {
    type: type.GET_ALBUM_DETAIL_SUCCESS,
    payload,
  };
};

export const deleteAlbumSuccess = (payload) => {
  return {
    type: type.DETETE_ALBUM_SUCCESS,
    payload,
  };
};

export const resetAlbumDetail = (payload) => {
  return {
  type: type.RESET_ALBUM_SUCCESS,
    payload,
  };
};

export const resetAlbum = (payload) => {
  return {
  type: type.RESET_DATA_ALBUM_SUCCESS,
    payload,
  };
};

export const updateAlbumBadgeCount = (payload) => {
  return {
    type: type.UPDATE_ALBUM_BADGE_COUNT,
    payload,
  };
};
